(ns rothko.theme.manatee.tabber)

(def main
  {:primary
   {}})
